/* global document window */
import Cookies from 'js-cookie';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import CreateAccountForm from './components/CreateAccountForm';

const CreateAccount = (props) => {
  const { redirectTo = '/profile' } = props;
  const { settings } = props;
  if (!settings.data) {
    return null;
  }
  if (Cookies.get('customerToken')) {
    window.location.href = redirectTo;
  }
  return ReactDOM.createPortal(
    <>
      <CreateAccountForm redirectTo={redirectTo} />
    </>,
    document.getElementById('c7-create-account')
  );
};

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps)(CreateAccount);
